import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Accordion } from '@hivebrite/design-system/Accordion';
import { Box } from '@hivebrite/design-system/Box';
import type { BoxProps } from '@hivebrite/design-system/Box';

import { useColorPickerContext } from 'hb-builder/hooks';

interface AccordionTitleProps {
  children?: React.ReactNode;
  title: string;
  isDrawerOpen?: boolean;
  isInitiallyOpen?: boolean;
}

const AccordionTitle = ({
  children,
  isDrawerOpen,
  isInitiallyOpen,
  title,
  ...props
}: AccordionTitleProps & BoxProps) => {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen || isDrawerOpen);

  const { resetAllColorPickers } = useColorPickerContext();

  const handleToggle = (bool) => {
    resetAllColorPickers?.();

    setIsOpen(bool);
  };

  useEffect(() => {
    if (!isInitiallyOpen) {
      setIsOpen(isDrawerOpen);
    }
  }, [isDrawerOpen, isInitiallyOpen]);

  return (
    <WrapperAccordion>
      <Accordion
        isOpen={isOpen}
        onToggle={handleToggle}
        title={title}
        triggerSticky
      >
        {({ ref }) => (
          <Box flexDirection="column" px={5} ref={ref} width="100%" {...props}>
            {children}
          </Box>
        )}
      </Accordion>
    </WrapperAccordion>
  );
};

export default AccordionTitle;

const WrapperAccordion = styled.div`
  width: 100%;
  > h2 {
    width: 100%;
    z-index: 2 !important; // it is 1 by default and it conflicts with the design-system/Inputs checkbox.
  }
`;
